import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'
import { isEmptyGuid } from '../../../../../utils/emptyGuid';

const SupplyChainCheck = ({ baseData }) => {
  const [isValid, setIsValid] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (!isEmptyGuid(baseData.supplier?.id) || !isEmptyGuid(baseData.storehouse?.id)) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [baseData])

  return (
    <>
      <StyledCircleCheckIconWrapper>
        <CircleCheckIcon variant={isValid ? 'done' : 'must'} />
      </StyledCircleCheckIconWrapper>
      <span>{t('articleAdmin:supplyChainData')}</span>
    </>
  )
}

export default SupplyChainCheck